var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { PostFragments } from "../../fragments";
;
export var getPostListQuery = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetPostListQuery {\n    getPostList {\n      ...PostFragments_post\n    }\n  } \n  ", "\n"], ["\n  query GetPostListQuery {\n    getPostList {\n      ...PostFragments_post\n    }\n  } \n  ", "\n"])), PostFragments.post);
export var withPostList = graphql(getPostListQuery, {
    props: function (_a) {
        var data = _a.data;
        var postList = [];
        if (data && !data.loading && data.getPostList) {
            postList = data.getPostList;
        }
        return {
            postList: postList,
            postListLoading: data ? data.loading : false,
        };
    }
});
var templateObject_1;
//# sourceMappingURL=PostListController.js.map


//////////////////
// WEBPACK FOOTER
// ../controller/dist/modules/post/PostListController.js
// module id = 1302
// module chunks = 0